export const RECRUIT_LOGO_IMAGE_SIZE = 60

export const LINKAREER_MAGAZINE_WIDTH_SIZE = 140
export const LINKAREER_MAGAZINE_HEIGHT_SIZE = 70

export const LINKAREER_MAGAZINE_IMAGE_RENDER_WIDTH = 140
export const LINKAREER_MAGAZINE_IMAGE_RENDER_HEIGHT = 76
